import React, { Component } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import classNames from "classnames";
import RegularButton from "../CustomButtons/Button";
import { BsThreeDots } from "react-icons/all";

import Overlay from "../Overlay/Overlay";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import { FileCopyOutlined } from "@material-ui/icons";
import { updateVendorProduct } from "../../api/index";
import { connect } from "react-redux";
import DiscountTag from "../../assets/img/discount-tag.png";
import {
  ClickAwayListener,
  Grow,
  IconButton,
  MenuList,
  MenuItem,
  Paper,
  Popper
} from '@material-ui/core';

const useStyles = makeStyles(styles);

function OpenContext({
  inStock,
  idx,
  editPrice,
  setContextOpened,
  sku,
  activeStore,
  updateLocal,
  canSetStock,
  canEditPrice,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setContextOpened(true);
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setContextOpened(false);
    setAnchorEl(null);
  };
  const handleClickMenuItem = (e, fxn) => {
    e.stopPropagation();
    e.preventDefault();
    switch (fxn) {
      case "toggle_stock":
        setLoading(true);
        markStock(idx, sku, inStock).then(() => {
          setLoading(false);
          handleClose();
        });
        break;
      case "discontinue":
        markDisable(idx, sku);
        handleClose();
        break;
      case "edit_price":
        editPrice(idx, sku);
        handleClose();
        break;
      default:
    }
  };

  const markStock = (idx, sku, inStock) => {
    const quantity = !inStock ? 1 : 0;
    const payload = { quantity };
    return updateVendorProperties(sku, payload).then(() => {
      updateLocal(idx, `${activeStore}_qty`, quantity);
    });
  };

  const markDisable = (idx, sku) => {
    const payload = { retailer_disabled: true };
    updateVendorProperties(sku, payload).then(() => {
      updateLocal(idx, "retailer_disabled", true);
    });
  };
  const updateVendorProperties = (sku, payload) => {
    return updateVendorProduct(sku)(payload);
  };

  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover);

  return (
    <div>
      <RegularButton
        disableRipple
        justIcon
        aria-controls="simple-menu"
        color="transparent"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <BsThreeDots />
      </RegularButton>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        transition
        disablePortal
        placement="bottom"
        className={classNames({
          [classes.popperClose]: !anchorEl,
          [classes.popperResponsive]: true,
          [classes.popperNav]: true,
        })}
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            id="profile-menu-list"
            style={{ transformOrigin: "0 0 0" }}
          >
            <Paper className={classes.dropdown}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList role="menu">
                  {canSetStock && <MenuItem
                    onClick={(e) => handleClickMenuItem(e, "toggle_stock")}
                    className={dropdownItem}
                  >
                    {inStock ? "Mark OOS" : "Mark In Stock"}
                  </MenuItem>}
                  {canSetStock && <MenuItem
                    onClick={(e) => handleClickMenuItem(e, "discontinue")}
                    className={dropdownItem}
                  >
                    Discontinue
                  </MenuItem> }
                  {canEditPrice && <MenuItem
                    onClick={(e) => handleClickMenuItem(e, "edit_price")}
                    className={dropdownItem}
                  >
                    Edit Price
                  </MenuItem>}
                </MenuList>
              </ClickAwayListener>
              {loading && (
                <Overlay
                  type={"loading"}
                  rootClasses={classes.overlayRoot}
                  containerClasses={classes.overlayContainer}
                />
              )}
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}

class InventoryTable extends Component {

  onClick = (e, key) => {
    const { onRowClickProxy } = this.props;
    e.preventDefault();
    e.stopPropagation();
    if (onRowClickProxy) {
      onRowClickProxy(key);
    }
  };

  allowAddItem = (product) => (idx) => {
    const { activeStore, openPricingModal, classes } = this.props;
    let result = (
      <div
        className={classes.addItemWrapper}
        onClick={() => openPricingModal(idx, product.sku_id, true)}
      >
        Add Item <AddCircleOutlineIcon />
      </div>
    );
    for (const prop in product) {
      let hasStorePrice = product[`${activeStore}_price`] > 0;
      if (hasStorePrice) {
        return (result = null);
      }
    }
    return result;
  };

  tableHead = this.props.showAllItems
    ? ["Product", "Title", "Subtitle", "SKU", "Volume", "Price", "Category", "Stock"]
    : [
        "Product",
        "Title",
        "Subtitle",
        "SKU",
        "Volume",
        "Price",
        "Category",
        "Stock",
        "",
      ];

  formatTableData = (product, idx) => {
    const {
      activeStore,
      setContextOpened,
      openPricingModal,
      markStock,
      markDisable,
      updateLocal,
      canSetStock, canEditPrice, canEditDeals
    } = this.props;

    let discounted = product[`${activeStore}_package_qty`];

    return this.props.showAllItems
      ? [
          <img src={product.image} />,
          product.title,
          product.subtitle,
          <span>
            {product.sku_id}
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigator.clipboard.writeText(product.sku_id)
              }}>
            <FileCopyOutlined/>
            </IconButton>
          </span>,
          product.volume_label,
          product[`${activeStore}_buy_price`] ? (
            <span>
              {"$" + product[`${activeStore}_buy_price`].toFixed(2)}{" "}
              {discounted ? (
                <img
                  style={{ marginLeft: 10, height: "1.5rem" }}
                  src={DiscountTag}
                />
              ) : null}
            </span>
          ) : (
            ""
          ),
          product.default_category,
          this.allowAddItem(product)(idx) || (
            <StockPill
              inStock={!!product[`${activeStore}_qty`]}
              retailerDisabled={product.retailer_disabled}
            />
          ),
        ]
      : [
          <img src={product.image} />,
          product.title,
          product.subtitle,
          <span>
            {product.sku_id}
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigator.clipboard.writeText(product.sku_id)
              }}>
            <FileCopyOutlined/>
            </IconButton>
          </span>,
          product.volume_label,
          product[`${activeStore}_buy_price`] ? (
            <span>
              {"$" + product[`${activeStore}_buy_price`].toFixed(2)}{" "}
              {discounted ? (
                <img
                  style={{ marginLeft: 10, height: "1.5rem" }}
                  src={DiscountTag}
                />
              ) : null}
            </span>
          ) : (
            ""
          ),
          product.default_category,
          <StockPill
            inStock={!!product[`${activeStore}_qty`]}
            retailerDisabled={product.retailer_disabled}
          />,
          <OpenContext
            updateLocal={updateLocal}
            inStock={product[`${activeStore}_qty`]}
            idx={idx}
            sku={product.sku_id}
            markStock={markStock}
            markDisable={markDisable}
            editPrice={openPricingModal}
            setContextOpened={setContextOpened}
            activeStore={activeStore}
            canSetStock={canSetStock}
            canEditPrice={canEditPrice}
            canEditDeals={canEditDeals}
          />,
        ];
  };



  render() {
    const {
      tableHeaderColor,
      hover,
      colorsColls,
      coloredColls,
      customCellClasses,
      customClassesForCells,
      striped,
      tableShopping,
      customHeadCellClasses,
      customHeadClassesForCells,
      classes,
      hits,
    } = this.props;

    if (!hits || hits.length == 0) {
      return null;
    }
    const tableData = this.props.hits.map((product, idx) => {
        if(product.merchant_id && product.sku_id.indexOf("CXP-") == 0){
          return null;
        }
        return this.formatTableData(product, idx)
    }).filter((product) => product !== null);
    return (
      <div className={classes.tableResponsive}>
        <Table className={classes.table}>
          {this.tableHead !== undefined ? (
            <TableHead className={classes[tableHeaderColor]}>
              <TableRow
                className={classes.tableRow + " " + classes.tableRowHead}
              >
                {this.tableHead.map((prop, key) => {
                  const tableCellClasses =
                    classes.tableHeadCell +
                    " " +
                    classes.tableCell +
                    " " +
                    cx({
                      [customHeadCellClasses[
                        customHeadClassesForCells.indexOf(key)
                      ]]: customHeadClassesForCells.indexOf(key) !== -1,
                      [classes.tableShoppingHead]: tableShopping,
                      [classes.tableHeadFontSize]: !tableShopping,
                    });
                  return (
                    <TableCell className={tableCellClasses} key={key}>
                      {prop}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
          ) : null}
          <TableBody>
            {tableData.map((prop, key) => {
              var rowColor = "";
              var rowColored = false;
              if (prop.color !== undefined) {
                rowColor = prop.color;
                rowColored = true;
                prop = prop.data;
              }
              const tableRowClasses = cx({
                [classes.tableRowBody]: true,
                [classes.tableRowHover]: hover,
                [classes[rowColor + "Row"]]: rowColored,
                [classes.tableStripedRow]: striped && key % 2 === 0,
                [classes.pointer]: true,
              });
              return (
                <TableRow
                  key={key}
                  hover={hover}
                  className={classes.tableRow + " " + tableRowClasses}
                  onClick={(e) => this.onClick(e, key)}
                >
                  {prop.map((prop, key) => {
                    const tableCellClasses =
                      classes.tableCell +
                      " " +
                      cx({
                        [classes[colorsColls[coloredColls.indexOf(key)]]]:
                          coloredColls.indexOf(key) !== -1,
                        [customCellClasses[customClassesForCells.indexOf(key)]]:
                          customClassesForCells.indexOf(key) !== -1,
                      });
                    if (prop && prop.colSpan && prop.data) {
                      return (
                        <TableCell
                          colSpan={prop.colSpan}
                          style={{ textAlign: "center" }}
                          className={tableCellClasses}
                          key={key}
                        >
                          {prop.data}
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell className={tableCellClasses} key={key}>
                        {prop}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    activeStore: state.app.activeStore
  }),
  {}
)(withStyles(styles)(InventoryTable));

function StockPill({ inStock, retailerDisabled }) {
  const classes = useStyles();
  let color = "google";
  let text = "In Stock";
  if (!inStock) {
    color = "danger";
    text = "OOS";
  }
  if (retailerDisabled) {
    color = "warning";
    text = "Discontinued";
  }

  return (
    <RegularButton className={classes.stockPill} size={"sm"} color={color}>
      {text}
    </RegularButton>
  );
}
InventoryTable.defaultProps = {
  tableHeaderColor: "gray",
  hover: false,
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: [],
};

InventoryTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  hover: PropTypes.bool,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,
  customCellClasses: PropTypes.arrayOf(PropTypes.string),
  customClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses: PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells: PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  // this will cause some changes in font
  tableShopping: PropTypes.bool,
};
